export const getExpenses = (state) => state.expenses;
